<div class="upsell-wrapper-cont" (click)="close()" [class.fadeOut]="fadeOut"></div>
<div class="content-upsell {{ animation }} animated" [class.showActionBar]="showActionBar">
  <ng-container *ngIf="isLoadingFligthsUpsell$ | async; else fligthsUpsell">
    <app-mobile-upsell-placeholder></app-mobile-upsell-placeholder>
  </ng-container>
  <ng-template #fligthsUpsell>
    <div class="header">
      <h1>
        {{ 'FLIGHT_RESULTS_MODULE.UPSELL.CUSTOMIZE_YOR_RATE' | transloco }}
      </h1>
      <h2>
        {{ 'FLIGHT_RESULTS_MODULE.UPSELL.CHOOSE_THE_RATE' | transloco }}
      </h2>
      <span class="back">
        <app-ds-button-icon
          [icon]="icons.Close"
          [buttonSize]="buttonIconSize"
          [iconSize]="16"
          (clickEvent)="close()">
        </app-ds-button-icon>
      </span>
    </div>
    <div content class="content-slide" *ngIf="fligthsUpsell$ | async as fligthsUpsell">
      <app-carousel [styleDots]="styleDots">
        <div content class="box-container partial" [class.one-option]="justOneOption(fligthsUpsell$ | async)"
          *ngFor="let option of (fligthsUpsell$ | async)?.UpsellOptions; let i = index">
          <div class="box-header">
            <div class="header-upper-content">
              <div class="header-text">
                <span class="title">
                  {{ option?.Families[0]?.Name | uppercase }}
                </span>
                <span class="code">
                  <ng-container *ngIf="option?.CabinTypeByFlights">
                    <ng-container *ngFor="let cabin of getflightClassUnique(option?.CabinTypeByFlights); let last = last">
                      {{ flightClassText(cabin) | titlecase }}
                      <span *ngIf="!last"> {{'INSTALLMENTS_INFO.SUBTITLE_LAST_CONCAT' | transloco}}</span>
                    </ng-container>
                  </ng-container>
                </span>
              </div>
              <div class="header-price">
                <!-- Temporarily Disabled -->
                <ng-container *ngIf="false">
                  <div class="price-tag" *ngIf="option.HasPrivateFare">
                    <app-member-rate-tag [tagType]="tagType$ | async"></app-member-rate-tag>
                  </div>
                </ng-container>
                <!-- / Temporarily Disabled -->
                <span class="price">
                  {{ calcUpsellItemValues(option.Amount?.Fare, option.Amount?.Taxes) | currencyFormat: option.Amount?.CurrencyCode }}
                </span>
              </div>
            </div>
          </div>
          <div class="box-content" *ngIf="option">
            <app-upsell-section [showBorder]="false" 
              [inclusions]="filterIncludedOptions(option)">
            </app-upsell-section>
            <app-upsell-section [showBorder]="showBorderForAtCharge(option)" 
              [inclusions]="filterAtChargeOptions(option)">
            </app-upsell-section>
            <app-upsell-section [showBorder]="showBorderForNotOffered(option)"
              [inclusions]="filterNotOfferedOptions(option)">
            </app-upsell-section>
          </div>
          <div class="box-button">
            <app-fixed-surface>
              <app-ds-button
                [labels]="{ ButtonLabel: 'BUTTONS.SELECT' | transloco }"
                (clickEvent)="selectUpsell(option, i)">
              </app-ds-button>
            </app-fixed-surface>
          </div>
        </div>
      </app-carousel>
    </div>
  </ng-template>
</div>
